import { render } from "./SupplierCard.vue?vue&type=template&id=0432700a"
import script from "./SupplierCard.vue?vue&type=script&lang=js"
export * from "./SupplierCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__